import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import DesignUnderLine from "../../components/ExcerciseTypes/Design/DesignUnderLine";
import DrawColor from '../../components/ExcerciseTypes/DrawColor';

const json = {
  1: {
    // Exercise num
    unit: "Unit 12",
    id: "SB3-U12-P83-E1",
    audio: "img/FriendsPlus/Page83/Audio/audio-e1-p83.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      // Row
      [
        // Column1
        { url: "img/FriendsPlus/Page83/E1/1.jpg" },
        {
          url: "img/FriendsPlus/Page83/E1/2.jpg",
          audioUrl: "img/FriendsPlus/Page83/Audio/tieude-e1-p83.mp3",
        },
        { url: "img/FriendsPlus/Page83/E1/3.jpg" },
      ],
      [
        // Column2
        {
          url: "img/FriendsPlus/Page83/E1/4.jpg",
          audioUrl: "img/FriendsPlus/Page83/Audio/hinh1-e1-p83.mp3",
        },
        {
          url: "img/FriendsPlus/Page83/E1/5.jpg",
          audioUrl: "img/FriendsPlus/Page83/Audio/hinh2-e1-p83.mp3",
        },
        {
          url: "img/FriendsPlus/Page83/E1/6.jpg",
          audioUrl: "img/FriendsPlus/Page83/Audio/hinh3-e1-p83.mp3",
        },
        {
          url: "img/FriendsPlus/Page83/E1/7.jpg",
          audioUrl: "img/FriendsPlus/Page83/Audio/hinh4-e1-p83.mp3",
        },
        {
          url: "img/FriendsPlus/Page83/E1/8.jpg",
          audioUrl: "img/FriendsPlus/Page83/Audio/hinh5-e1-p83.mp3",
        },
        {
          url: "img/FriendsPlus/Page83/E1/9.jpg",
          audioUrl: "img/FriendsPlus/Page83/Audio/hinh6-e1-p83.mp3",
        },
      ],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 12",
    id: "SB3-U12-P83-E2",
    audio: "img/FriendsPlus/Page83/Audio/audio-e2-p83.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page83/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page83/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page83/Audio/tieude-e2-p83.mp3",
        },
        { url: "img/FriendsPlus/Page83/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page83/E2/4.jpg" }],
    ],
  },
  3: {
    unit: 'Unit 12',
    id: 'WB5-U12-P83-E3',
    audio: '',
    video: '',
    component: DrawColor,
    exerciseKey: 'img/FriendsPlus/Page83/E3/Key/answerKey.png',
    titleQuestion: [{ num: '3', title: 'Circle the short vowels. Underline the long vowels.', color: "#1F4199" }],
    question: {
      Write: {
        underlineStyle: {},
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        listStyle: {
          normal: {},
          circle: { padding: 3, border: 'solid 2px', borderRadius: '50%', borderColor: 'rgb(0, 168, 236)' },
          underline: { borderBottom: '2px solid gray', borderColor: 'rgb(0, 168, 236)' },
          // square: { padding: 3, border: 'solid 2px', borderColor: 'gray' },
        },
        // limitSelect: 1,
        listWords: [
          "c|a|p|e",	//0
          "t|i|m|e",	//1
          "c|a|p",	//2
          "c|u|p",	//3
          "p|i|n",	//4
          "p|i|n|e ",	//5
        ],
        answers: { '2-2': 'circle', '4-2': 'circle', '0-2': 'underline', '1-2': 'underline', '3-2': 'circle', '5-2': 'underline' },
        initialValue: {},
      },
      Layout: `
        <div style='display:flex;'>
          <div style='margin:20px;'>
            <div><b>1</b> T<span style='padding: 3px 7px;border: 2px solid rgb(0, 168, 236); border-radius: 50%;'>i</span>m</div>
            <div><b>5</b> <input id='0' type='Circle' /></div>
          </div>
          <div style='margin:20px;'>
            <div><b>2</b> c<u style='text-decoration-color:rgb(0,168,236)'>u</u>be</div>
            <div><b>6</b> <input id='1' type='Circle' /></div>
          </div>
          <div style='margin:20px;'>
            <div><b>3</b> <input id='2' type='Circle' /></div>
            <div><b>7</b> <input id='3' type='Circle' /></div>
          </div>
          <div style='margin:20px;'>
            <div><b>4</b> <input id='4' type='Circle' /></div>
            <div><b>8</b> <input id='5' type='Circle' /></div>
          </div>
        </div>
      `,
    },
  },
  4: {
    // Exercise num
    unit: "Unit 12",
    id: "SB3-U12-P83-E4",
    audio: "img/FriendsPlus/Page83/Audio/audio-e4-p83.mp3",
    video: "",
    component: DesignUnderLine,
    totalInput: 4,
    exerciseKey: "img/FriendsPlus/Page83/E4/Key/answerKey.png",
    questionImage: [
      // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page83/E4/1.jpg' },
        { url: 'img/FriendsPlus/Page83/E4/2.jpg', audioUrl: 'img/FriendsPlus/Page83/Audio/tieude-e4-p83.mp3' },
        { url: 'img/FriendsPlus/Page83/E4/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page83/E4/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page83/E4/5.jpg' },
        { url: 'img/FriendsPlus/Page83/E4/6.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page83/E4/7.jpg' },
        { url: 'img/FriendsPlus/Page83/E4/8.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page83/E4/9.jpg' },
        { url: 'img/FriendsPlus/Page83/E4/10.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page83/E4/11.jpg' },
        { url: 'img/FriendsPlus/Page83/E4/12.jpg', input: 4 },
        { url: 'img/FriendsPlus/Page83/E4/13.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page83/E4/14.jpg' },
        { url: 'img/FriendsPlus/Page83/E4/15.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page83/E4/16.jpg' },
        { url: 'img/FriendsPlus/Page83/E4/17.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page83/E4/18.jpg' },
        { url: 'img/FriendsPlus/Page83/E4/19.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page83/E4/20.jpg' },
        { url: 'img/FriendsPlus/Page83/E4/21.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page83/E4/22.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page83/E4/23.jpg' },
      ],
    ],
  },
  5: {
    // Exercise num
    unit: "Unit 12",
    id: "SB3-U12-P83-E12",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page83/E5/1.jpg" }]],
  },
};

export default json;
